/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  import/no-extraneous-dependencies,
  react/prop-types
*/
import './index.scss';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

const SubHeader = createReactClass({

  propTypes: {
    onCTAClick: PropTypes.func.isRequired,
  },

  getInitialState() {
    return {
      className: this.props.className || '',
    };
  },

  render() {
    return (
      <div className={`m-signer-mobile-sub-header ${this.state.className}`}>
        <FormattedMessage
          id="signer.subheader.delegate.message"
          description="text in signer flow while reassigning, informing that the new signer is not authorize to access the document"
          defaultMessage="Not the authorized signer?" />
        <a className='m-signer-mobile-sub-header-cta' onClick={this.props.onCTAClick}>
          <FormattedMessage
            id="signer.subheader.delegate.ctaMessage"
            description="text in signer flow while reassigning, asking signer to pick new signer to reassign"
            defaultMessage="Assign to someone else" />
        </a>
        { this.props.children }
      </div>
    );
  },
});

module.exports = SubHeader;
